import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@crashx/ui";
import { audioEngine } from "./AudioEngine.js";
import { useAudioStore } from "./audioStore.js";
import { StrokeIcon } from "../../ui/StrokeIcon.js";
export function AudioControls() {
  const { t } = useTranslation();
  const muted = useAudioStore((state) => state.muted);
  const [failed, setFailed] = useState(false);
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        className="cx-icon-button"
        aria-label={t(muted ? "audio.unmute" : "audio.mute")}
        aria-pressed={!muted}
        onClick={() => {
          if (!muted) useAudioStore.getState().setMuted(true);
          else
            void audioEngine.unlock().then((ok) => {
              setFailed(!ok);
              if (ok) useAudioStore.getState().setMuted(false);
            });
        }}
      >
        <StrokeIcon name={muted ? "muted" : "sound"} />
      </Button>
      {failed ? (
        <span role="status" className="text-xs text-muted">
          {t("audio.unavailable")}
        </span>
      ) : null}
    </div>
  );
}
